import React, { Component } from "react";
import { Grid, Typography } from "@material-ui/core";
import { FormattedMessage, IntlProvider, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { cancelResetPasswordWatcher, resetPasswordWatcher } from "../../redux/actions/loginactioncreators";
import PasswordField from "../fields/PasswordField";
import CognitoPasswordValidator from "../changePasswordForm/CognitoPasswordValidator";
import PropTypes from "prop-types";
import challengeShape from "../../proptypes/challengeShape";
import { TextField } from "../fields/TextField";
import { Button } from "../fields/Button";

const validator = new CognitoPasswordValidator(8, 99, true, true, true, true);

export class ForcedResetPassword extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loginErrorMessages: [],
      validationErrors: {},
      username: null,
      password: null,

      newPassword: {
        value: "",
        valid: false
      },
      code: {
        value: "",
        valid: false
      },
      verifyPassword: {
        value: "",
        valid: false
      },
      submitEnabled: false,
    }
  }

  handleCodeChange = event => {
    this.setState({
      code: {
        value: event.target.value,
        valid: event.target.value ? event.target.value.length > 0 : false
      },
      submitEnabled: this.state.newPassword.valid && this.state.verifyPassword.valid && event.target.value ? event.target.value.length > 0 : false
    });
  }

  handlePasswordChange = event => {
    const pwdInputId = "newPassword";
    const currentPWDValue = document.getElementById(pwdInputId).value;
    const matchPwdInputId = "newPasswordConfirm";
    const matchValue = document.getElementById(matchPwdInputId).value;
    const errors = [];

    errors.push(...validator.validatePasswordFormat(currentPWDValue));
    errors.push(...validator.validatePasswordRules(currentPWDValue, matchValue));
    let isValid = errors.length === 0 ? true : false;

    this.setState({
      newPassword: {
        value: event.target.password,
        valid: isValid
      },
      submitEnabled: this.state.code.valid && this.state.verifyPassword.valid && isValid
    });
  }

  handleVerifyPasswordChange = event => {
    const pwdInputId = "newPasswordConfirm";
    const currentPWDValue = document.getElementById(pwdInputId).value;
    const matchPwdInputId = "newPassword";
    const matchValue = document.getElementById(matchPwdInputId).value;
    const errors = [];

    errors.push(...validator.validatePasswordFormat(currentPWDValue));
    errors.push(...validator.validatePasswordRules(currentPWDValue, matchValue));
    const isValid = errors.length === 0 ? true : false;

    this.setState({
      verifyPassword: {
        value: event.target.password,
        valid: isValid
      },
      submitEnabled: this.state.code.valid && this.state.newPassword.valid && isValid
    });
  }

  handleCloseResetPassword = () => {
    this.props.cancelResetPasswordWatcher()
  }

  handleOnSubmit = () => {
    this.props.resetPasswordWatcher(
      {
        step: "CONFIRM_RESET_PASSWORD",
        username: this.props.username.trim().toLowerCase(),
        code: this.state.code.value.trim(),
        password: this.state.newPassword.value.trim()
      }
    )
  }

  render() {

    return (
      <main id="S1Transport">
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h6">{
              <FormattedMessage
                id="forcedResetPassword.blurbTitle"
                defaultMessage="Reset your password, please"
                description="Title shown for forced password reset blurb."
              />
            }</Typography>
            <Typography>
              <FormattedMessage
                id="forcedResetPassword.Blurb"
                defaultMessage="To keep every account secure, an email with a verification code was sent to the email address associated with your login. If you do not receive a verification code, please contact support at the number provided in the 'Contact Us' link above."
                description="Blurb shown when a forced password reset is required, explaining the verification code process."
              />
            </Typography>
            <br />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="code"
              name="code"
              label={<FormattedMessage id="forcedResetPassword.verifyCode" defaultMessage="Verification Code" description="Label for verification code input field in forced password reset." />}
              onChange={this.handleCodeChange}
              error={this.state.validationErrors.code}
              autoFocus={true}
            />
            <PasswordField
              id="newPassword"
              name="newPassword"
              label={<FormattedMessage id="forcedResetPassword.passwordMin" defaultMessage="Password (8 Minimum)" description="Label for new password input field in forced password reset." />}
              passwordValidator={validator}
              onChange={this.handlePasswordChange}
            />
            <PasswordField
              id="newPasswordConfirm"
              name="newPasswordConfirm"
              label={<FormattedMessage id="forcedResetPassword.confirmPassword" defaultMessage="Confirm Password" description="Label for confirm password input field in forced password reset." />}
              match={this.state.newPassword.value}
              passwordValidator={validator}
              onChange={this.handleVerifyPasswordChange}
            />
          </Grid>
        </Grid>
            <br />
        <Grid container className="justify-end">
          <Grid item>
            <Button
              id="cancelResetPassword"
              name="cancelResetPassword"
              onClick={this.handleCloseResetPassword}
              variant="outlined"
              color="primary">
                <FormattedMessage id="forcedResetPassword.cancel" defaultMessage="Cancel" description="Button text for canceling forced password reset." />
            </Button>
          </Grid>
          <Grid item >
            <Button
              id="submitResetPassword"
              name="submitResetPassword"
              onClick={this.handleOnSubmit}
              variant="contained"
              disabled={!this.state.submitEnabled}
              color="primary">
                <FormattedMessage id="forcedResetPassword.resetPassword" defaultMessage="Reset Password" description="Button text for submitting forced password reset." />
            </Button>
          </Grid>
        </Grid>
      </main>
    )
  }

}
ForcedResetPassword.propTypes = {
  challenge: challengeShape,
  intl: PropTypes.objectOf(IntlProvider),
  username: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resetPasswordWatcher: PropTypes.func.isRequired,
  cancelResetPasswordWatcher: PropTypes.func.isRequired,
}
const mapStateToProps = state => {
  return {
    username: state.loginForm.username,
    loginErrorMessages: state.loginForm.loginErrorMessages,
    challenge: state.loginForm.challenge || null
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    resetPasswordWatcher,
    cancelResetPasswordWatcher
    // add other watcher sagas to this object to map them to props
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ForcedResetPassword));